import { z } from 'zod';
/**
 * Thư viện WBS template — APM-601, spec mục 9.
 *
 * Template là **điểm xuất phát** cho AI sinh plan (`APM-602`), không phải kế
 * hoạch cuối cùng. Nó ở mức "work package" (tầng 1 theo spec 9.1); chia tiếp
 * xuống mức giờ là việc AI làm theo yêu cầu, dựa trên context của từng dự án.
 */
export const ArchitectureType = z.enum([
    'web_fullstack',
    'backend_only',
    'frontend_only',
    'mobile',
    'microservices',
    'other',
]);
export const WbsTemplateItemView = z.object({
    id: z.uuid(),
    parentId: z.uuid().nullable(),
    title: z.string(),
    description: z.string().nullable(),
    taskTypeSlug: z.string().nullable(),
    techStackSlug: z.string().nullable(),
    estimateHours: z.number().nullable(),
    position: z.number().int().nonnegative(),
    /** Id các hạng mục phải xong trước. `APM-602` biến chúng thành dependency thật. */
    dependsOn: z.array(z.uuid()),
});
export const WbsTemplateView = z.object({
    id: z.uuid(),
    name: z.string(),
    slug: z.string(),
    description: z.string().nullable(),
    architecture: ArchitectureType,
    isActive: z.boolean(),
    /**
     * `true` = template dựng sẵn, dùng chung mọi tổ chức và **chỉ đọc**.
     * Giao diện hiện nút "Nhân bản" thay cho nút "Sửa".
     */
    isBuiltIn: z.boolean(),
    techStackIds: z.array(z.uuid()),
    items: z.array(WbsTemplateItemView),
    /** Tổng giờ ước lượng của mọi hạng mục — để PM ước lượng thô ngay khi chọn. */
    totalEstimateHours: z.number().nonnegative(),
    createdAt: z.iso.datetime(),
});
export const CreateWbsTemplateInput = z.object({
    name: z.string().trim().min(1).max(120),
    description: z.string().max(5_000).optional(),
    architecture: ArchitectureType,
    techStackIds: z.array(z.uuid()).optional(),
});
export const UpdateWbsTemplateInput = z.object({
    name: z.string().trim().min(1).max(120).optional(),
    description: z.string().max(5_000).nullable().optional(),
    architecture: ArchitectureType.optional(),
    isActive: z.boolean().optional(),
    techStackIds: z.array(z.uuid()).optional(),
});
export const CreateWbsItemInput = z.object({
    title: z.string().trim().min(1).max(300),
    description: z.string().max(5_000).optional(),
    /** Có giá trị = hạng mục tầng 2. Không lồng sâu hơn — khớp mô hình `task`. */
    parentId: z.uuid().optional(),
    taskTypeSlug: z.string().max(60).optional(),
    techStackSlug: z.string().max(60).optional(),
    estimateHours: z.number().positive().max(10_000).optional(),
});
export const UpdateWbsItemInput = z.object({
    title: z.string().trim().min(1).max(300).optional(),
    description: z.string().max(5_000).nullable().optional(),
    taskTypeSlug: z.string().max(60).nullable().optional(),
    techStackSlug: z.string().max(60).nullable().optional(),
    estimateHours: z.number().positive().max(10_000).nullable().optional(),
    /** Toàn bộ danh sách phụ thuộc, thay thế danh sách cũ. */
    dependsOn: z.array(z.uuid()).optional(),
});
export const ReorderWbsItemsInput = z.object({
    /** Toàn bộ id hạng mục **cùng một tầng**, theo thứ tự mới. */
    itemIds: z.array(z.uuid()).min(1),
});
export const CloneWbsTemplateInput = z.object({
    name: z.string().trim().min(1).max(120).optional(),
});
//# sourceMappingURL=wbs-template.js.map